export const SET_FETCHING_STATUS = "AUTH:SET_FETCHING_STATUS";
export const SET_AUTH_DATA = "AUTH:SET_AUTH_DATA";
export const CLEAR_AUTH_DATA = "AUTH:CLEAR_AUTH_DATA";
export const ADD_SUBSCRIBE_STATUS = "AUTH:ADD_SUBSCRIBE_STATUS";
export const ADD_APP_FIELDS = "AUTH:ADD_APP_FIELDS";
export const ADD_LAST_VISIT = "AUTH:ADD_LAST_VISIT";
export const SET_TEST_RESULT = "AUTH:SET_TEST_RESULT";
export const SET_REFERRAL_MODAL = "AUTH:SET_REFERRAL_MODAL";
